import {
  DomElementAlignment,
  IconButton,
  OdinIcon,
  OdinIconSize,
  ResizableHandle,
  ResizablePanel,
  Tooltip,
} from '@myosh/odin-components';
import clsx from 'clsx';
import { t } from 'i18next';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { selectSidePanelOpen, setSidePanelOpen } from '../../redux/slices/side-panel-slice';
import SidePanelContent from './side-panel-content.component';
import SidePanelNav from './side-panel-nav.component';

const MIN_RESIZABLE_PANEL_WIDTH = 40;
const expandButtonStyles =
  'absolute w-4 top-4 -left-4 border-2 border-transparent !bg-gray-4 rounded-l shadow-left-2 focus:outline-hidden transition-all expand-navigator';
const closeAllButtonStyles =
  'cursor-pointer whitespace-nowrap text-right text-sm leading-7 text-primary-2 px-2 pt-5 pb-2';

export default function ActiveSidePanel() {
  const dispatch = useAppDispatch();
  const sidePanelVisible = useAppSelector(selectSidePanelOpen);

  const [displayCollapsed, setDisplayCollapsed] = useState(true);

  const navigationStyles = clsx('flex flex-col h-full bg-gray-4 transition-all shadow-left-2 shrink-0', {
    'w-10': displayCollapsed,
    'w-80': !displayCollapsed,
  });

  const onCloseAllClick = () => {
    dispatch(setSidePanelOpen(false));
  };

  const onExpandNavigatorClick = () => {
    setDisplayCollapsed((prev) => !prev);
  };

  return (
    <>
      {sidePanelVisible ? (
        <>
          <ResizableHandle className="h-full" />
          <ResizablePanel
            id="active-record-panel"
            order={2}
            defaultSize={MIN_RESIZABLE_PANEL_WIDTH}
            minSize={MIN_RESIZABLE_PANEL_WIDTH}
            className="h-full"
          >
            <SidePanelContent />
          </ResizablePanel>
          <div className={navigationStyles}>
            <div className="relative" data-testid="expand-navigator">
              <IconButton
                icon={displayCollapsed ? 'ChevronLeft' : 'ChevronRight'}
                iconSize={OdinIconSize.Small}
                iconClassName="relative -left-1.5"
                classNames={expandButtonStyles}
                onClick={onExpandNavigatorClick}
              />
            </div>
            <div className={closeAllButtonStyles} onClick={onCloseAllClick}>
              {displayCollapsed ? (
                <Tooltip
                  description={t('closeAll')}
                  debounceTime={200}
                  tooltipClassName="bg-mono-1"
                  tooltipAlignment={DomElementAlignment.TopRight}
                >
                  <OdinIcon size={OdinIconSize.Medium} icon="X" className="relative -left-1 w-8" />
                </Tooltip>
              ) : (
                <span className="underline">{t('closeAll')}</span>
              )}
            </div>
            <ul className="custom-scroll grow list-none overflow-y-auto">
              <SidePanelNav displayCollapsed={displayCollapsed} />
            </ul>
          </div>
        </>
      ) : null}
    </>
  );
}
